import React, { useEffect, useState } from 'react';
import Header from '../../components/header/index.js';
import TimezoneInfo from '../../components/timezoneInfo/index.js';
import ReloadButton from '../../components/reloadButton/index.js';
import NotificationTools from '../../components/notificationTools/index.js';
import BrandChartsContainer from '../../containers/brandCharts/index.js';
import DropdownSearch from '../../components/dropdownSearch/index.js';
import { useSelector } from 'react-redux';
import { getUser } from '../../redux/user/actions.js';
import { getIsPortalPreview, getSelectedPortal } from '../../redux/portal/actions.js';
import API from '../../services/api.js';

const BrandChartsScreen = () => {
  const [lastUpdated, setLastUpdated] = useState('');
  const [templates, setTemplates] = useState([]);
  const [selectedDashboard, setSelectedDashboard] = useState(null);
  const user = useSelector(getUser);
  const portal = useSelector(getSelectedPortal);
  const isPortalPreview = useSelector(getIsPortalPreview);
  const isBrandUser = user?.type === 'BRAND';

  const actions = [
    { type: 'reactComponent', value: <TimezoneInfo key="timezone-info" /> },
    {
      type: 'reactComponent',
      value: <ReloadButton key="reload-btn" contentName="Campaigns data" lastUpdatedCB={setLastUpdated} />
    }
  ];

  if (!isBrandUser && !isPortalPreview) {
    actions.push({ type: 'reactComponent', value: <NotificationTools key="notification-btn" /> });
  }

  useEffect(() => {
    const fetchDashboard = async () => {
      API.getTemplates(
        '',
        `(compatibleDatasources = ['AUDIENCE_M'] OR compatibleDatasources = ['TRAFFIC_M'] OR compatibleDatasources = ['MOBILE_M'] OR compatibleDatasources = ['AUDIENCE_M', 'MOBILE_M']) AND enabled = true`
      )
        .then(response => {
          const templates =
            response.templates.filter(template => template.collection === 'ANALYTICS' && template.headers !== 'cms') ||
            [];
          if (templates && templates.length > 0) {
            const selectedDashboard = templates[0];
            setSelectedDashboard(selectedDashboard);
            setTemplates(templates);
          } else {
            setSelectedDashboard(null);
            setTemplates([]);
          }
        })
        .catch(error => {
          console.error('Error fetching dashboards:', error);
        });
    };
    fetchDashboard();
    setLastUpdated(new Date().toISOString());
  }, []);

  return (
    <div className="d-flex flex-column flex-fill">
      <Header
        title={'Analytics'}
        icon={'analyticsDark'}
        filters={
          <div className="d-flex">
            <DropdownSearch
              label="Dashboard"
              options={templates.map(template => ({ label: template.displayName, value: template }))}
              selected={
                selectedDashboard ? { label: selectedDashboard.displayName, value: selectedDashboard.id } : null
              }
              onSelect={setSelectedDashboard}
            />
          </div>
        }
        actions={actions}
      />
      <BrandChartsContainer lastUpdated={lastUpdated} selectedDashboard={selectedDashboard} portal={portal} />
    </div>
  );
};

export default BrandChartsScreen;
